import * as React from 'react';

import API from 'src/services/api';
import { TooltipIcon } from 'src/components';

interface IListItemProps {
  item: any;
  openLinks: (copying: boolean) => void;
  drawerOpen: boolean;
  newBulkId?: number;
  profileParameterName: string;
}
interface IListItemState {
  downloadingExcel: boolean;
}

class ListItem extends React.Component<IListItemProps, IListItemState> {
  state: IListItemState = {
    downloadingExcel: false,
  };

  viewLinks = () => {
    if (this.props.item.numberOfLinksCreated !== 0) {
      this.props.openLinks(false);
    }
  };
  copyLinks = () => {
    if (this.props.item.numberOfLinksCreated !== 0) {
      this.props.openLinks(true);
    }
  };
  downloadExcel = async () => {
    const { item } = this.props;
    const step = item.uploadSteps[item.uploadSteps.length - 1];
    this.setState({
      downloadingExcel: true,
    });
    await API.LINK_UPLOAD.downloadBulkExcel(step.id);
    this.setState({
      downloadingExcel: false,
    });
  };

  render() {
    const { item, drawerOpen, newBulkId, profileParameterName } = this.props;
    const { downloadingExcel } = this.state;
    const noLinks = item.numberOfLinksCreated === 0;
    const linksFailed =
      item.numberOfLinksRequested -
      item.numberOfLinksCreated -
      item.numberOfLinksDuplicate;
    const isNew = newBulkId && newBulkId === item.id;
    const processingStatus =
      item.uploadSteps[item.uploadSteps.length - 1].processingStatus;
    const isDone = processingStatus === 'done';
    return (
      <li
        className={`border  mb-2 transition-shadow ${
          drawerOpen
            ? 'shadow-lg bg-blue-light border-blue'
            : 'bg-grey border-white'
        }`}
      >
        <div className="py-2 px-4 flex items-center justify-between">
          <TooltipIcon
            className="mr-4 text-xs"
            positionY="top"
            positionX="left"
            type={isDone ? 'success' : 'loading'}
            width={isDone ? 'w-16' : 'w-24'}
            text={isDone ? 'Done' : 'Processing'}
            isLoading={!isDone}
          />
          <span className="mr-4">{item.createdOn}</span>

          <div className="flex-1 flex flex-wrap">
            <p className="m-2">
              <span className="opacity-75 italic">{profileParameterName}:</span>{' '}
              {item.profile.name}
            </p>
            {item.template.name && (
              <p className="m-2">
                <span className="opacity-75 italic">Template:</span>{' '}
                {item.template.name}
              </p>
            )}
          </div>
          <span className="font-mono text-base">{item.name}</span>
        </div>
        <div className="mb-3 mx-4 flex items-center justify-between py-2 px-4 bg-grey-light">
          <div>
            {isDone ? (
              <>
                {!noLinks && (
                  <span className="mr-4 text-green-dark">
                    <strong>{item.numberOfLinksCreated}</strong> Link
                    {item.numberOfLinksCreated === 1 ? '' : 's'} created
                  </span>
                )}
                {item.numberOfLinksDuplicate > 0 && (
                  <span className="mr-4 text-orange-dark">
                    <strong>{item.numberOfLinksDuplicate}</strong> Link
                    {item.numberOfLinksDuplicate === 1 ? '' : 's'} duplicate
                  </span>
                )}
                {linksFailed > 0 && (
                  <span className="mr-4 text-red">
                    <strong>{linksFailed}</strong> Link
                    {linksFailed === 1 ? '' : 's'} failed
                  </span>
                )}
              </>
            ) : (
              <span className="mr-4">
                Processing <strong>{item.numberOfLinksRequested}</strong> Link
                {item.numberOfLinksRequested === 1 ? '' : 's'}
              </span>
            )}
          </div>
          <div>
            <button
              onClick={this.viewLinks}
              className={`inline-block mx-1 py-2 px-3 text-center text-sm rounded border border-grey focus:outline-none ${
                noLinks
                  ? 'bg-grey cursor-default'
                  : 'bg-blue transition-shadow hover:shadow-md'
              }`}
            >
              View
            </button>
            <button
              onClick={this.copyLinks}
              className={`inline-block mx-1 py-2 px-3 text-center text-sm rounded border border-grey focus:outline-none ${
                noLinks
                  ? 'bg-grey cursor-default'
                  : 'bg-yellow transition-shadow hover:shadow-md'
              }`}
            >
              Copy
            </button>
            <button
              onClick={this.downloadExcel}
              className={`inline-block mx-1 py-2 px-3 text-center text-sm rounded border border-grey focus:outline-none bg-grey-dark transition-shadow hover:shadow-md ${
                downloadingExcel ? 'loader' : ''
              }`}
            >
              Download as Excel
            </button>
          </div>
        </div>
        {isNew && (
          <div
            className={`py-3 px-4 ${
              isDone ? 'bg-green' : 'bg-blue'
            } text-white`}
          >
            {isDone ? (
              <>
                Your bulk upload was successfully created and processed. The
                finished trackinglinks in an Excel file have been sent to your
                email-address.
              </>
            ) : (
              <>
                Your bulk upload was successfully created and is being
                processed. This might take some time, depending on the amount of
                requested links. You will receive the finished trackinglinks in
                an Excel file that will be sent to your email-address.
              </>
            )}
          </div>
        )}
      </li>
    );
  }
}
export default ListItem;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkStart/components/ListItem.tsx